export default "__VITE_ASSET__6b6d9a53__"